import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Tm1Button } from '@tm1/design-system-react';
import { injectIntl } from 'react-intl';
import messages from '../../printing-message';
export const EditPrinterConfigurationActions = injectIntl(({ intl, onCancel, onSave, saveDisabled = false }) => (_jsxs(_Fragment, { children: [_jsx(Tm1Button, { onClick: onCancel, variant: "outline", children: intl.formatMessage(messages.cancelPrinterConfiguration) }), _jsx(Tm1Button, { onClick: () => {
                if (!saveDisabled) {
                    onSave();
                }
            }, disabled: saveDisabled, variant: "solid", children: intl.formatMessage(messages.savePrinterConfiguration) })] })));
